import React from 'react';

import { Box, Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setGridDefinition } from 'reducers/reviewCreationSlice';
import { setReviewCreationGridDefinition } from 'reducers/reviewCreationV1Slice';
import { replaceNewScore } from 'screens/admin/Reviews/CalibrationSettings/common/helper';

import { Pen } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { NumberInput } from 'uiToolkitV1/InputV2/NumberInput';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const ScoreEditBody = ({ onClose, onApply, initialScore, maxScore }) => {
  const [tempScore, setTempScore] = React.useState(initialScore);

  const onChangeHandler = () => {
    onApply({ newScore: tempScore });
    onClose();
  };
  return (
    <PaperWithShadow width="220px" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.08)">
      <Box px={3}>
        <TextBodyMedium bold p={1}>
          Edit Score
        </TextBodyMedium>

        <Divider color="neutral.CFD7DF" my={1} />
        <Flex justify="space-between" p="1" alignItems="center">
          <TextLabel mr={4}>Score</TextLabel>
          <NumberInput
            defaultValue={tempScore}
            max={maxScore}
            min={0}
            onChange={(_, valueAsNumber) => setTempScore(valueAsNumber)}
            format={(val) => (Number.isNaN(val) ? '' : val)}
          />
        </Flex>
      </Box>
      <Divider color="neutral.CFD7DF" mb={4} mt={2} />
      <Flex gap={4} px={4} mb={1}>
        <Button variant="outlined" flexGrow={1} onClick={onClose}>
          Cancel
        </Button>
        <Button minW="75px" flexGrow={1} onClick={onChangeHandler}>
          Apply
        </Button>
      </Flex>
    </PaperWithShadow>
  );
};

export const EditScoreComp = ({
  initialScore,
  maxScore,
  direction,
  gridDefinition,
  isSimplifiedReviewCreation = false,
}) => {
  const dispatch = useDispatch();
  const onChangeHandler = ({ newScore }) => {
    const updatedGrid = replaceNewScore(gridDefinition, newScore, initialScore, direction);
    if (isSimplifiedReviewCreation) {
      dispatch(setReviewCreationGridDefinition(updatedGrid));
    } else {
      dispatch(setGridDefinition(updatedGrid));
    }
  };
  return (
    <Popover placement="auto">
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger>
            <Box>
              <Pen ml={2} boxSize="14px" color="icon.g2" cursor="pointer" />
            </Box>
          </PopoverTrigger>
          <PopoverContent bg="transparent" border="none" boxShadow="none" width="min-content">
            <PopoverBody maxW="maxContent">
              {isOpen && (
                <ScoreEditBody
                  onClose={onClose}
                  onApply={onChangeHandler}
                  initialScore={initialScore}
                  maxScore={maxScore}
                />
              )}
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};
